module.exports = __webpack_public_path__ + "img/2025-08-16c_2.4a2a2b35.jpg";